import React, { useState } from "react";
import { getDatabase, ref, get, update } from "firebase/database";
import { toast } from "react-toastify";

const TambahSaldo = () => {
    const [userId, setUserId] = useState("");
    const [saldo, setSaldo] = useState("");
    const [loading, setLoading] = useState(false);

    const handleTambahSaldo = async () => {
        if (!userId || !saldo || isNaN(saldo) || saldo <= 0) {
            toast.error("ID pengguna dan jumlah saldo harus valid!");
            return;
        }

        setLoading(true);

        try {
            const db = getDatabase();
            const userRef = ref(db, `users/${userId}`);
            const snapshot = await get(userRef);

            if (snapshot.exists()) {
                const userData = snapshot.val();
                const currentSaldo = parseFloat(userData.saldo) || 0; // Konversi saldo ke angka
                const newSaldo = currentSaldo + parseFloat(saldo); // Tambah saldo dengan angka

                // Update hanya saldo, tidak merubah data lain
                await update(userRef, { saldo: newSaldo });

                toast.success(
                    `Saldo berhasil ditambahkan! Saldo baru pengguna adalah Rp ${newSaldo.toLocaleString(
                        "id-ID"
                    )}`
                );
                setUserId("");
                setSaldo("");
            } else {
                toast.error("ID pengguna tidak ditemukan!");
            }
        } catch (error) {
            console.error("Error saat menambahkan saldo:", error);
            toast.error("Terjadi kesalahan saat menambahkan saldo!");
            setUserId("");
            setSaldo("");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-3xl font-bold mb-4">Tambah Saldo Pengguna</h1>
            <div className="bg-gray-100 p-6 rounded-md shadow-md">
                <div className="mb-4">
                    <label htmlFor="userId" className="block font-medium mb-2">
                        ID Pengguna
                    </label>
                    <input
                        type="text"
                        id="userId"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        placeholder="Masukkan ID pengguna"
                        className="w-full p-2 border rounded-md"
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="saldo" className="block font-medium mb-2">
                        Jumlah Saldo (Rp)
                    </label>
                    <input
                        type="number"
                        id="saldo"
                        value={saldo}
                        onChange={(e) => setSaldo(e.target.value)}
                        placeholder="Masukkan jumlah saldo"
                        className="w-full p-2 border rounded-md"
                    />
                </div>
                <button
                    onClick={handleTambahSaldo}
                    disabled={loading}
                    className={`w-full p-2 rounded-md text-white ${
                        loading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-500 hover:bg-blue-600"
                    }`}
                >
                    {loading ? "Menambahkan..." : "Tambah Saldo"}
                </button>
            </div>
        </div>
    );
};

export default TambahSaldo;
